import { useEffect, useState } from "react";
import { format, formatNumber } from "../../utils/helpers";
import Button, { ButtonGroup } from "../common/Button";
import Flow from "../common/Flow";
import Modal from "../common/Modal";
import Table, { TableBar } from "../common/Table";
import Typography from "../common/Typography";
import { TabItem, Tabs } from "../common/Tabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKipSign } from "@fortawesome/pro-light-svg-icons";

function ContractModal({ store }) {
  const [tab, setTab] = useState('new');
  const [filtered, setFiltered] = useState();
  const [showTerms, setShowTerms] = useState(false);
  const [selectedTerms, setSelectedTerms] = useState(null);
  const contracts = store.state.contracts;

  useEffect(() => {
    if (contracts) {
      const results = contracts.filter((c) => {
        if (tab == 'fulfilled') {
          return c.fulfilled;
        }
        if (tab == 'accepted') {
          return !c.fulfilled && c.accepted;
        }
        if (tab == 'new') {
          return !c.accepted;
        }

        return results;
      });

      setFiltered(results)
    }
  }, [tab, contracts])

  const accept = (contractId) => {
    store.acceptContract(contractId);
  }
  const fulfill = (contractId) => {
    store.fulfillContract(contractId);
  }

  const clickHandle = (idx) => {
    setShowTerms(true)
    setSelectedTerms(idx);
  }

  const calcTotalRequired = (contract) => {
    let required;
    contract.terms.deliver.map(item => required =+ item.unitsRequired);

    return required;
  }

  const calcTotalFulfilled = (contract) => {
    let fulfilled;

    contract.terms.deliver.map(item => fulfilled =+ item.unitsFulfilled);

    return fulfilled;
  }

  return (
    <Modal store={store} $padding>
      <Flow $space={6}>
        <Typography as="h1" fontSize="2xl">Contracts</Typography>
        <Tabs>
          <TabItem $active={tab == 'new'} onClick={() => setTab('new')}>New</TabItem>
          <TabItem $active={tab == 'accepted'} onClick={() => setTab('accepted')}>Accepted</TabItem>
          <TabItem $active={tab == 'fulfilled'} onClick={() => setTab('fulfilled')}>Fulfilled</TabItem>
        </Tabs>
        <Table $style="striped">
          <thead>
            <tr>
              <th>Faction</th>
              <th>Type</th>
              <th>On Accepted</th>
              <th>On Fulfilled</th>
              <th>Delivers</th>
              <th>Accepted</th>
              <th>fulfilled</th>
              {tab == 'new' && (
                <>
                  <th>Expiration</th>
                  <th>DeadlineToAccept</th>
                  <th>Deadline</th>
                </>
              )}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered && filtered.map((contract, idx) => (
              <tr key={idx}>
                <td>{contract.factionSymbol}</td>
                <td>{contract.type}</td>
                <td><FontAwesomeIcon icon={faKipSign} /> {formatNumber(contract.terms.payment.onAccepted)}</td>
                <td><FontAwesomeIcon icon={faKipSign} /> {formatNumber(contract.terms.payment.onFulfilled)}</td>
                <td className="action" onClick={() => clickHandle(idx)}>
                  <TableBar $current={calcTotalFulfilled(contract)} $max={calcTotalRequired(contract)} />
                </td>
                <td>{contract.accepted ? 'Yes' : 'No'}</td>
                <td>{contract.fulfilled ? 'Yes' : 'No'}</td>
                {tab == 'new' && (
                  <>
                    <td>{format(contract.expiration)}</td>
                    <td>{format(contract.deadlineToAccept)}</td>
                    <td>{format(contract.terms.deadline)}</td>
                  </>
                )}
                <td>
                  <ButtonGroup>
                    <Button $action onClick={() => accept(contract.id)} $disabled={contract.accepted || contract.fulfilled}>Accept</Button>
                    <Button $action onClick={() => fulfill(contract.id)} $disabled={!contract.accepted || contract.fulfilled} >Fulfill</Button>
                  </ButtonGroup>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Flow>
      {showTerms && (
        <Modal store={store} close={() => setShowTerms(false)} $padding>
          <Flow $space={6}>
            <Typography as="h1" fontSize="xl">Delivers</Typography>
            <Table $style="striped">
              <thead>
                <tr>
                  <th>Symbol</th>
                  <th>Destination</th>
                  <th>Required</th>
                </tr>
              </thead>
              <tbody>
                {contracts[selectedTerms] && contracts[selectedTerms].terms.deliver.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.tradeSymbol}</td>
                    <td>{item.destinationSymbol}</td>
                    <td>
                      <TableBar title={`${item.unitsFulfilled}/${item.unitsRequired}`} $current={item.unitsFulfilled} $max={item.unitsRequired} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Flow>
        </Modal>
      )}
    </Modal>
  )
}

export default ContractModal;
